module.exports = __webpack_public_path__ + "static/media/24UHCHR16.fd233936.jpg";